import { Component } from 'react'
import { withRouterProps } from '../../../utils'
import GoalForm from './GoalForm'
import { Page } from '../elements'

class AddGoal extends Component {
  backToDashboard = () => {
    this.props.navigate('/goals')
  }

  render() {
    return (
      <Page>
        <Page.MainTitle>Let's get your goal off the ground</Page.MainTitle>
        <GoalForm handleClose={this.backToDashboard} />
      </Page>
    )
  }
}

export default withRouterProps(AddGoal)
